

/// <reference path="EventPhaseItem.ts" />

// Generated class EventPhaseSection_ManagedObject

class EventPhaseSection_ManagedObject extends EventPhaseItem
{

    // Relationship: lines
    protected _lines:MIOManagedObjectSet = null;
    get lines():MIOManagedObjectSet {
        return this.valueForKey('lines');
    }
    addLinesObject(value:EventPhaseLine) {
        this._addObjectForKey(value, 'lines');
    }
    removeLinesObject(value:EventPhaseLine) {
        this._removeObjectForKey(value, 'lines');
    }
}
